import { FilterOperationType, IFilter } from '@chax-at/prisma-filter-common';
import { ICompetenceDomainFilter } from 'common/interface/filter.interface';
import { Components } from '../generated/api';
import { Api } from '../api.client';

export async function fetchCompetenceDomainsForSchoolClass(
  schoolClassId: number,
): Promise<Components.Schemas.CompetenceDomainDto[]> {
  const availableCompetenceDomainsFilter: IFilter<ICompetenceDomainFilter> = {
    filter: [
      { field: 'isTemplate', type: FilterOperationType.Eq, value: false },
      { field: 'schoolSubject.isTemplate', type: FilterOperationType.Eq, value: false },
      { field: 'schoolSubject.schoolClassId', type: FilterOperationType.Eq, value: schoolClassId },
    ],
    order: [{ field: 'name', dir: 'asc' }],
  };
  const result = await Api.Routes.CompetenceDomain.retrieve({ $filter: availableCompetenceDomainsFilter });
  return result.rows;
}

export async function fetchCompetenceDomainTemplatesForSchoolLevel(
  schoolLevel: number,
): Promise<Components.Schemas.CompetenceDomainDto[]> {
  const availableCompetenceDomainsFilter: IFilter<ICompetenceDomainFilter> = {
    filter: [
      { field: 'isTemplate', type: FilterOperationType.Eq, value: true },
      { field: 'schoolSubject.isTemplate', type: FilterOperationType.Eq, value: true },
      { field: 'schoolSubject.schoolLevel', type: FilterOperationType.Eq, value: schoolLevel },
    ],
    order: [{ field: 'name', dir: 'asc' }],
  };
  const result = await Api.Routes.CompetenceDomain.listTenantTemplates({ $filter: availableCompetenceDomainsFilter });
  return result.rows;
}

export async function fetchGlobalCompetenceDomainTemplatesForTemplateSet(
  schoolLevel: number,
  templateSetId: number,
): Promise<Components.Schemas.CompetenceDomainDto[]> {
  const availableCompetenceDomainsFilter: IFilter<ICompetenceDomainFilter> = {
    filter: [
      { field: 'schoolSubject.schoolLevel', type: FilterOperationType.Eq, value: schoolLevel },
      { field: 'schoolSubject.templateSetId', type: FilterOperationType.Eq, value: templateSetId },
    ],
    order: [{ field: 'name', dir: 'asc' }],
  };
  const result = await Api.Routes.CompetenceDomain.retrieveGlobalTemplates({
    $filter: availableCompetenceDomainsFilter,
  });
  return result.rows;
}

export async function fetchCompetenceDomain(domainId: number): Promise<Components.Schemas.CompetenceDomainDto> {
  const result = await Api.Routes.CompetenceDomain.get({ domainId });
  return result.data;
}
